/**
 * sr-popup.js — SR PopupEngine v1.4
 * 纯 UI 引擎：open / close / toast
 * 不含任何业务逻辑，不做注册、不做轮询、不做条件判断
 * 所有"何时弹"的决策由 C 层 (SRController) 直接调用
 *
 * v1.4: 增加 display 切换 — overlay 初始 display:none，open 时 display:flex，close 时 display:none
 */
(function(){
'use strict';

/* ═══════════════ Global Popup CSS ═══════════════ */
var css = [
  '.sr-popup-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(26,26,26,0.45);z-index:9999;display:none;align-items:center;justify-content:center;opacity:0;visibility:hidden;transition:opacity .4s ease,visibility .4s ease;padding:20px}',
  '.sr-popup-overlay.sr-popup-active{opacity:1;visibility:visible}',
  '.sr-popup-overlay .sr-popup-panel{position:relative;max-width:480px;width:100%;max-height:90vh;overflow-y:auto;background:#fff;border-radius:6px;box-shadow:0 12px 48px rgba(0,0,0,.15);transform:translateY(20px);transition:transform .4s ease}',
  '.sr-popup-overlay.sr-popup-active .sr-popup-panel{transform:translateY(0)}',
  '.sr-popup-close{position:absolute;top:12px;right:14px;width:32px;height:32px;background:none;border:none;cursor:pointer;font-size:20px;color:#999;line-height:1;z-index:2;transition:color .2s}',
  '.sr-popup-close:hover{color:#333}',
  '.sr-toast-wrap{position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:99999;display:flex;flex-direction:column;align-items:center;gap:8px;pointer-events:none}',
  '.sr-toast{padding:10px 24px;border-radius:4px;font-size:13px;opacity:0;transform:translateY(-10px);transition:all .3s ease;pointer-events:auto;font-family:inherit;box-shadow:0 4px 16px rgba(0,0,0,.1)}',
  '.sr-toast.sr-toast-show{opacity:1;transform:translateY(0)}',
  '.sr-toast-success{background:#2d5016;color:#fff}',
  '.sr-toast-error{background:#8b1a1a;color:#fff}',
  '.sr-toast-info{background:#451A00;color:#fff}'
].join('\n');
var styleEl = document.createElement('style');
styleEl.id = 'sr-popup-engine-css';
styleEl.textContent = css;
document.head.appendChild(styleEl);

/* Toast container */
var toastWrap = document.createElement('div');
toastWrap.className = 'sr-toast-wrap';
document.body.appendChild(toastWrap);

/* ═══════════════ PopupEngine ═══════════════ */
var engine = {

  /**
   * 打开弹窗（纯 UI 操作，不做任何条件判断）
   * @param {string|Element} idOrEl - overlay 的 id 或 DOM 元素
   */
  open: function(idOrEl) {
    var el = typeof idOrEl === 'string' ? document.getElementById(idOrEl) : idOrEl;
    if (!el) { console.warn('[srPopup] open: element not found'); return; }
    console.log('[srPopup] open:', el.id || el.className);
    this._closeCurrent();
    el.style.display = 'flex';
    /* 双帧延迟确保 display 变更生效后再触发 transition */
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        el.classList.add('sr-popup-active');
      });
    });
    this._current = el;
    this._locked = true;
    document.body.style.overflow = 'hidden';
  },

  /**
   * 关闭弹窗
   * @param {string|Element} [idOrEl] - 可选，不传则关闭当前弹窗
   */
  close: function(idOrEl) {
    if (idOrEl) {
      var el = typeof idOrEl === 'string' ? document.getElementById(idOrEl) : idOrEl;
      if (!el) return;
      el.classList.remove('sr-popup-active');
      el.style.display = 'none';
      if (this._current === el) {
        this._current = null;
        this._locked = false;
        document.body.style.overflow = '';
      }
    } else {
      this._closeCurrent();
    }
  },

  /**
   * Toast 提示
   */
  toast: function(msg, type) {
    type = type || 'info';
    var t = document.createElement('div');
    t.className = 'sr-toast sr-toast-' + type;
    t.textContent = msg;
    toastWrap.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add('sr-toast-show'); });
    setTimeout(function(){
      t.classList.remove('sr-toast-show');
      setTimeout(function(){ t.remove(); }, 300);
    }, 3000);
  },

  /* ── internal ── */
  _current: null,
  _locked: false,

  _closeCurrent: function() {
    if (this._current) {
      this._current.classList.remove('sr-popup-active');
      this._current.style.display = 'none';
      this._current = null;
    }
    this._locked = false;
  }
};

/* ═══════════════ Global close handlers ═══════════════ */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' && engine._current) engine.close();
});
document.addEventListener('click', function(e) {
  if (!engine._current || !engine._locked) return;
  if (e.target === engine._current) engine.close();
});

/* Export */
window.srPopup = engine;
console.log('[srPopup] v1.4 engine ready');

})();
